import React, { useState } from "react";
import "./CommentsView.scss";
import { Close, Send } from "@material-ui/icons";
import { Comments } from "../../hoc/withComments";

type Props = {
    visible: boolean;
    close: () => void;
    comments: Comments[];
    chapterName: string;
    addComment: (comment: string) => Promise<any>;
    resolve: (id: string) => any;
};

const CommentsView: React.FC<Props> = (props) => {
    const [text, setText] = useState("");
    const [loading, setLoading] = useState(false);

    const addComment = async () => {
        const comment = text;
        setText("");
        setLoading(true);
        props.addComment(comment).finally(() => setLoading(false));
    };

    return (
        <div className="comments_view" hidden={!props.visible}>
            <div className="comments_backdrop"></div>
            <div className="comments_slide">
                <div className="header">
                    <h5>
                        Comments <span>({props.comments.length})</span>
                    </h5>
                    <div onClick={props.close} className="close__btn">
                        <Close style={{ fill: "var(--primary-color)" }} />
                    </div>
                </div>
                <div className="chapter_name">Part: {props.chapterName}</div>
                <div className="body comment__editor">
                    {props.comments.map((comment) => (
                        <React.Fragment key={comment.id}>
                            <div className="part comment__editor__head">
                                <div className="userpic"></div>
                                <div className="username">
                                    {comment.user_name}
                                    <p>{comment.user_intent}</p>
                                </div>
                            </div>
                            <p>{comment.comment}</p>
                            <div
                                className="resolve"
                                onClick={() => props.resolve(comment.id)}
                            >
                                Resolve Comment
                            </div>
                            <div className="devider" />
                        </React.Fragment>
                    ))}
                </div>
                {/* <div className="footer">
                    <textarea
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        placeholder="Write your comment here"
                        disabled={loading}
                    />
                    <button
                        disabled={loading}
                        onClick={addComment}
                        className="close__btn"
                        style={{
                            backgroundColor: "var(--primary-color)",
                            border: "none",
                        }}
                    >
                        <Send style={{ fill: "#ffffff" }} />
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default CommentsView;
